export type SupplyStatus = 
  | 'tedarik-bekliyor'
  | 'tedarik-bekleniyor'
  | 'tedarik-surecinde'
  | 'tedarik-tamamlandi'
  | 'tedarik-iptal'
  | 'filo-tedarik-edildi' 
  | 'spot-tedarik-edildi'
  | 'spot-teklif-bekleniyor'
  | 'teklif-topla'
  | 'faturalandirildi'
  | 'iptal';

export type ProcessStatus = 
  | 'yukleme-bekliyor'
  | 'yukleme-devam'
  | 'yukleme-tamamlandi'
  | 'tasima-yolunda'
  | 'bosaltma-bekliyor'
  | 'bosaltma-devam'
  | 'bosaltma-tamamlandi';

export const PROCESS_STATUS_CONFIG: Record<ProcessStatus, { label: string; color: string; bgColor: string }> = {
  'yukleme-bekliyor': { label: 'Yükleme Bekliyor', color: '#F59E0B', bgColor: '#FEF3C7' },
  'yukleme-devam': { label: 'Yükleme Devam Ediyor', color: '#3B82F6', bgColor: '#DBEAFE' },
  'yukleme-tamamlandi': { label: 'Yükleme Tamamlandı', color: '#059669', bgColor: '#D1FAE5' },
  'tasima-yolunda': { label: 'Taşıma Yolunda', color: '#6366F1', bgColor: '#E0E7FF' },
  'bosaltma-bekliyor': { label: 'Boşaltma Bekliyor', color: '#EC4899', bgColor: '#FCE7F3' },
  'bosaltma-devam': { label: 'Boşaltma Devam Ediyor', color: '#8B5CF6', bgColor: '#EDE9FE' },
  'bosaltma-tamamlandi': { label: 'Boşaltma Tamamlandı', color: '#059669', bgColor: '#D1FAE5' },
};

export const PROCESS_FLOW_ORDER: ProcessStatus[] = [
  'yukleme-bekliyor',
  'yukleme-devam',
  'yukleme-tamamlandi',
  'tasima-yolunda',
  'bosaltma-bekliyor',
  'bosaltma-devam',
  'bosaltma-tamamlandi',
];

export const getNextProcessStatus = (current: ProcessStatus): ProcessStatus | null => {
  const currentIndex = PROCESS_FLOW_ORDER.indexOf(current);
  if (currentIndex === -1 || currentIndex >= PROCESS_FLOW_ORDER.length - 1) return null;
  return PROCESS_FLOW_ORDER[currentIndex + 1];
};

export const canAdvanceProcess = (current: ProcessStatus): boolean => {
  return getNextProcessStatus(current) !== null;
};

export interface SupplyRecord {
  id: string;
  sevkKodu: string;
  planKodu?: string;
  yuklemeTalepTarihi: string;
  aracAtamaTarihi: string;
  siparisKodu: string;
  hizliArama: string;
  durum: SupplyStatus;
  yuklemeMusterisiAd: string;
  yuklemeIl: string;
  yuklemeIlce: string;
  yuklemeAdres: string;
  teslimMusterisiAd: string;
  teslimIl: string;
  teslimIlce: string;
  teslimAdres: string;
  istenenTeslimTarihi?: string;
  aracTipi: string;
  aracTuru?: string;
  assignedVehicleId?: string | number | null;
  pickupWarehouseId?: string | number | null;
  deliveryWarehouseId?: string | number | null;
  pickupCustomerId?: string | number | null;
  deliveryCustomerId?: string | number | null;
  pickupShiftId?: string | number | null;
  deliveryShiftId?: string | number | null;
  pickupLatitude?: number | string | null;
  pickupLongitude?: number | string | null;
  deliveryLatitude?: number | string | null;
  deliveryLongitude?: number | string | null;
  movementType?: string;
  yukTipi: string;
  yukAgirlik: number;
  yukHacim: number;
  palletCount?: number;
  vehicleCount?: number;
  stopCount?: number;
  mesafe: number;
  sure: number;
  maliyet: number;
  targetPrice?: number;
  kesinFiyat?: number;
  faturaNo?: string;
  requireReferenceWaybill?: boolean;
  phoneOnlyQuote?: boolean;
  shipmentContactPhone?: string;
  telefon?: string;
  dorsePlaka?: string;
  seferKm?: number;
  navlun?: number;
  teklifTlKm?: number;
  operasyonTakipKod?: string;
  operasyonTakipYuklenecekVardiya?: string;
  talepOlusturan?: string;
  faturaBasligi?: string;
  mail?: string;
  lojistikTuru?: string;
  nakliyeciTip?: string;
  islemDurum?: string;
  aracDurum?: string;
  aracAtamasiGerceklestiren?: string;
  komisyon?: number;
  genelToplam?: number;
  gerceklesenTlKm?: number;
  yuklemeIlIlce?: string;
  bosaltmaIlIlce?: string;
  surucuBilgileri?: string;
  cekici?: string;
  aciklama?: string;
  ugarmaBedeli?: number;
  beklemeBedeli?: number;
  hammaliyeBedeli?: number;
  yatmaBedeli?: number;
  faturaTutari?: number;
  faturaTarihi?: string;
  muhasebeIletilmeTarihi?: string;
  siparisGorselleri?: Array<{ id: string; url: string; name: string }>;
  irsaliyeGorselleri?: Array<{ id: string; url: string; name: string }>;
  faturaGorselleri?: Array<{ id: string; url: string; name: string }>;
  yuklemeBelgeleri?: Array<{ id: string; url: string; name: string; type: 'irsaliye' | 'tutanak' | 'Other' }>;
  bosaltmaBelgeleri?: Array<{ id: string; url: string; name: string; type: 'teslim' | 'tutanak' | 'Other' }>;
  yuklemeIrslaliyeNo?: string;
  yuklemeTutanakNo?: string;
  yuklemeBelge1?: string;
  yuklemeBelge2?: string;
  yuklemeBelge3?: string;
  bosaltmaTeslimBelgeNo?: string;
  bosaltmaTutanakNo?: string;
  bosaltmaBelge1?: string;
  bosaltmaBelge2?: string;
  bosaltmaBelge3?: string;
  aracPlaka?: string;
  surucuAd?: string;
  notlar?: string;
  araNoktalar?: string;
  nearestHubName?: string;
  nearestHubKm?: number | null;
  islemDurum?: ProcessStatus;
  aracDurum?: ProcessStatus;
  createdAt: string;
  updatedAt: string;
  workiomRecordId?: string;
}

export interface ColumnFilter {
  field: string;
  value: string;
  operator: 'contains' | 'equals' | 'startsWith' | 'endsWith';
}

export interface TableSort {
  field: string;
  direction: 'asc' | 'desc';
}

export interface TableGrouping {
  field: string;
  expanded: { [key: string]: boolean };
}

export const SUPPLY_STATUS_CONFIG: Record<SupplyStatus, { label: string; color: string; bgColor: string }> = {
  'tedarik-bekliyor': { label: 'Tedarik Bekliyor', color: '#C1388A', bgColor: '#FDE7F3' },
  'tedarik-bekleniyor': { label: 'Tedarik Bekleniyor', color: '#C1388A', bgColor: '#FDE7F3' },
  'tedarik-surecinde': { label: 'Tedarik Surecinde', color: '#2563EB', bgColor: '#DBEAFE' },
  'tedarik-tamamlandi': { label: 'Tedarik Tamamlandi', color: '#059669', bgColor: '#D1FAE5' },
  'tedarik-iptal': { label: 'Tedarik Iptal', color: '#6B7280', bgColor: '#F3F4F6' },
  'filo-tedarik-edildi': { label: 'Filo Tedarik Edildi', color: '#3B82F6', bgColor: '#DBEAFE' },
  'spot-tedarik-edildi': { label: 'Spot Tedarik Edildi', color: '#60A5FA', bgColor: '#DBEAFE' },
  'spot-teklif-bekleniyor': { label: 'Spot Tedarik Teklif Bekleniyor', color: '#8B5CF6', bgColor: '#F3E8FF' },
  'teklif-topla': { label: 'Teklif Topla', color: '#8B5CF6', bgColor: '#EDE9FE' },
  'faturalandirildi': { label: 'Faturalandırıldı', color: '#10B981', bgColor: '#D1FAE5' },
  'iptal': { label: 'İptal', color: '#6B7280', bgColor: '#F3F4F6' },
};
